<template>
  <div>
    <hr-co-input
      ref="input"
      :value="state.filter"
      :label="label"
      class="HRField HRField__hr-co-input"
      v-bind="$attrs"
      :invalid="invalid"
      @input="query"
      @blur="blur"
      @focus="focus"
      @click="click"
    >
      <template v-slot:invalid class="HRField__invalid">{{
        errorMessage
      }}</template>
    </hr-co-input>
    <div
      v-if="state.isListVisible"
      aria-hidden="false"
      class="co-select--popper u-no-rhythm co-popper is-light"
      role="tooltip"
      data-popper-placement="bottom-start"
      data-testid="hr-select-list"
    >
      <div class="co-select-dropdown">
        <div class="co-scrollbar">
          <div class="co-select-dropdown__wrap co-scrollbar__wrap">
            <ul class="co-scrollbar__view co-select-dropdown__list">
              <li
                v-for="(item, index) in state.theListFiltered"
                :key="index"
                class="co-select-dropdown__item"
                @click="selectItem(item)"
              >
                <span>
                  {{ item[itemKey] }}
                </span>
              </li>
            </ul>
          </div>
          <div class="co-scrollbar__bar is-horizontal">
            <div class="co-scrollbar__thumb"></div>
          </div>
          <div class="co-scrollbar__bar is-vertical">
            <div class="co-scrollbar__thumb"></div>
          </div>
        </div>
      </div>
      <div class="co-popper__arrow" data-popper-arrow=""></div>
    </div>
  </div>
</template>

<script>
import { reactive, ref, onMounted, onBeforeUnmount } from 'vue';
import HrCoInput from '@/components/hr-co-input.vue';
import { COUNTRY } from '@/core/country';
import store from '@/store';

export default {
  name: 'hr-select',
  components: { HrCoInput },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
    invalid: {
      type: Boolean,
      default: null,
    },
    errorMessage: {
      type: String,
      default: 'Enter correct value',
    },
    label: {
      type: [String],
      default: null,
    },
  },
  emits: ['input', 'blur', 'focus', 'click'],
  setup(props, { emit }) {
    const state = reactive({
      theValue: props.value,
      theList: [],
      theListFiltered: [],
      filter: props.value,
      isListVisible: false,
      input: {},
      inputVal: '',
      closeList: (e) => {
        if (!input.value.$el.contains(e.target)) {
          state.isListVisible = false;
        }
      },
    });
    const input = ref(null);
    const itemKey =
      store.state.onboarding.countryCode === COUNTRY.GB ? 'state' : 'code';

    function initialize() {
      if (props.list.length > 0) {
        state.theListFiltered = state.theList = props.list;
      }
    }
    initialize();

    function blur() {
      emit('blur');
    }

    function focus() {
      emit('focus');
    }

    function click() {
      state.isListVisible = true;
    }

    onBeforeUnmount(() => {
      document.removeEventListener('click', state.closeList);
    });

    onMounted(() => {
      document.addEventListener('click', state.closeList);
    });

    async function selectItem(item) {
      state.isListVisible = false;
      state.filter = item[itemKey];
      emit('update:value', state.filter, item);
    }

    function query(filterOrigin, obj, evt) {
      const filter = filterOrigin.toLowerCase();

      state.input = {
        type: evt.type,
        key: evt.key,
        keyCode: evt.keyCode,
        code: evt.code,
      };
      state.inputVal = obj;

      state.isListVisible = true;

      state.theListFiltered = state.theList.filter((item) => {
        return (
          item.description?.toLowerCase().includes(filter) ||
          item.code?.toLowerCase().includes(filter) ||
          item.state?.toLowerCase().includes(filter)
        );
      });
    }

    return {
      state,
      input,
      blur,
      focus,
      click,
      selectItem,
      query,
      itemKey,
    };
  },
};
</script>

<style scoped>
.co-select--popper {
  width: 100%;
}
.co-select--popper > .co-popper__arrow {
  top: -25px;
}
.co-select-dropdown {
  top: -20px;
  position: absolute;
  width: 100%;
  z-index: auto;
}
.co-select-dropdown__item {
  font-size: 14px;
  padding: 0 16px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #333;
  height: 34px;
  line-height: 34px;
  box-sizing: border-box;
  cursor: pointer;
  margin-top: 0;
  display: flex;
  align-items: center;
}
.co-select-dropdown__item:hover {
  background-color: rgb(249, 249, 251);
}
.co-popper__arrow {
  position: absolute;
  left: 0px;
  right: 0px;
  margin: 0 auto;
}
.co-scrollbar {
  overflow: hidden;
  position: relative;
}
.co-scrollbar__wrap {
  overflow-y: scroll;
  height: 100%;
}
@media only screen and (max-width: 768px) {
  .HRField__hr-co-input,
  .co-select-dropdown__item {
    font-size: 16px;
  }
}
</style>
